"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowBackCircle = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var ArrowBackCircle = function () { return (react_1.default.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0zM8.58 12.432l3.6 3.6a.6.6 0 001.02-.432V8.4a.6.6 0 00-1.02-.42l-3.6 3.6a.612.612 0 000 .852z", clipRule: "evenodd" })); };
exports.ArrowBackCircle = ArrowBackCircle;
//# sourceMappingURL=arrow-back-circle.js.map